// The Choose Systems ducted rail's paging position: which page of the
// server's order is loaded, and whether the rows beyond each type's lead
// cards have been revealed ("Show more").
export type DuctedPaging = {
  pageNumber: number;
  tailRevealed: boolean;
};

// Back to the rail's first view — page one, each type's lead cards showing.
// Every result-set change (a filter, chip, fuel, sort, sizing or matching
// change) lands here so the new order is read from the top.
export const resetDuctedPaging = (paging: DuctedPaging): void => {
  // eslint-disable-next-line no-param-reassign
  paging.pageNumber = 1;
  // eslint-disable-next-line no-param-reassign
  paging.tailRevealed = false;
};
